import { Action } from "@ngrx/store";
import { ConfigState } from "../reducers/config.reducer";

export const RESET_STATE = "[config] ResetState";
export const UPDATE = "[config] Update";

/**
 * Every action is comprised of at least a type and an optional
 * payload. Expressing actions as classes enables powerful
 * type checking in reducer functions.
 *
 * See Discriminated Unions: https://www.typescriptlang.org/docs/handbook/advanced-types.html#discriminated-unions
 */

export class ResetStateAction implements Action {
  readonly type = RESET_STATE;
  constructor() {
    // No payload as the LogoutAction resets state
  }
}
export class UpdateAction implements Action {
  readonly type = UPDATE;
  constructor(public payload: Partial<ConfigState>) {}
}
/**
 * Export a type alias of all actions in this action group
 * so that reducers can easily compose action types
 */
export type Actions = ResetStateAction | UpdateAction;



// WEBPACK FOOTER //
// ./src/app/store/actions/config.actions.ts